import { call, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { getCurrentSubfolder, getCurrentGallection } from '../selectors';
import type { Action } from 'redux-actions';
import type { MakeDeviationCurrentGallectionCoverPayload } from '../actions';
import setGallectionCover from './setGallectionCover';

function* makeDeviationCurrentGallectionCover(
  action: Action<MakeDeviationCurrentGallectionCoverPayload>
): SagaIterator {
  const deviation = action.payload;

  // if we're inside a subfolder, make sure we change the cover on that - not the parent
  const currentSubfolder: ReturnType<typeof getCurrentSubfolder> = yield select(
    getCurrentSubfolder
  );
  const currentGallection: ReturnType<typeof getCurrentGallection> =
    yield select(getCurrentGallection);
  const gallection = currentSubfolder || currentGallection;

  if (!gallection) {
    return;
  }

  yield call(setGallectionCover, {
    gallection,
    deviation,
  });
}

export default makeDeviationCurrentGallectionCover;
